import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
export var formatQuickFilterPayload = function formatQuickFilterPayload(filtervalue) {
  var dynamicContractKey = filtervalue === 'part_time' || filtervalue === 'full_time' ? 'job_type' : 'contract_type';

  var quickFilterObj = _defineProperty({}, dynamicContractKey, [filtervalue]);

  return quickFilterObj;
};